<template>
  <v-form v-model="valid" ref="form">
    <v-text-field
      ref="title"
      dense
      v-model="title"
      label="Tên khoản thu"
      placeholder="Nhập Tên Khoản Thu"
      required
      outlined
    ></v-text-field>
    <v-text-field
      outlined
      ref="code"
      dense
      v-model="code"
      label="Mã"
      disabled
    ></v-text-field>
    <currency-input
      dense
      v-model="price"
      label="Khoản thu"
      placeholder="Nhập Khoản Thu"
    ></currency-input>
     <v-select
      :items="option"
      outlined
      ref="type"
      dense
      v-model="type"
      label="Phân loại"
    ></v-select>
  </v-form>
</template>

<script>
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import moment from 'moment'
export default {
  components: { CurrencyInput },
  data: () => ({
    option: ['Khoản thu dài hạn', 'Khoản thu ngắn hạn', 'Khoản thu khác'],
    valid: true,
    title: '',
    price: '',
    type: '',
    code: 'SP' + moment().format('YYYYDDMM') + Math.floor(Math.random() * 1000),
  }),
  created() {
    this.reset()
  },
  methods: {
    validate() {
      this.$refs.form.validate()
    },
    reset() {
      this.code = moment().format('YYYYDDMM') + Math.floor(Math.random() * 1000)
      this.title = ''
      this.price = 0
      this.type = ''
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      return {
        title: this.title,
        price: this.price,
        type: this.type,
        code: this.code,
      }
    },
  },
}
</script>

<style scoped>
</style>
